const SEARCH_PATH = "/community/search";
const SEARCH_KEYS = ["q", "sort", "quick", "region", "country", "category", "collection"];

export function getCommunitySearchReturnTo(
  value: string | string[] | undefined,
): string | undefined {
  if (typeof value !== "string" || value.split("?")[0] !== SEARCH_PATH) return;
  const params = new URLSearchParams(value.slice(SEARCH_PATH.length + 1).split("#")[0]);
  const search = new URLSearchParams();
  for (const key of SEARCH_KEYS) {
    const entry = params.get(key);
    if (entry) search.set(key, entry);
  }
  return search.size ? `${SEARCH_PATH}?${search}` : SEARCH_PATH;
}

export function withCommunityReturnTo(href: string, returnTo?: string): string {
  const searchHref = getCommunitySearchReturnTo(returnTo);
  if (!searchHref) return href;
  const [pathAndSearch, hash] = href.split("#");
  const [path, query] = pathAndSearch.split("?");
  const params = new URLSearchParams(query);
  params.set("returnTo", searchHref);
  return `${path}?${params}${hash ? `#${hash}` : ""}`;
}

export function getCommunityProductHref(
  shopSlug: string | null | undefined,
  handle: string | null | undefined,
  returnTo?: string,
): string | undefined {
  if (!shopSlug) return;
  const shopPath = `/community/${encodeURIComponent(shopSlug)}`;
  return withCommunityReturnTo(
    handle ? `${shopPath}/products/${encodeURIComponent(handle)}` : `${shopPath}#products`,
    returnTo,
  );
}
